import qs from "qs";
import { apiGet, ApiCallParams, apiPut, apiPost } from "../baseService";
import {
  CardDto,
  PinDto,
  CardPinUpdateVm,
  TransactionStatement,
  ConfirmCardPinUpdateVm,
  CardCriteria,
  TransactionDto
} from "./domain";

export async function getCardDataApi() {
  const response = await apiGet(`/api/cards`);

  if (response.data) {
    const result: CardDto = response.data;
    return result;
  }

  return undefined;
}

export async function getCardPinApi(params: ApiCallParams<string>) {
  const response = await apiGet(`/api/cards/${params}/pin`);

  if (response.data) {
    const result: PinDto = response.data;
    return result;
  }

  return undefined;
}

export async function putNewCardPinApi(params: ApiCallParams<CardPinUpdateVm>) {
  const response = await apiPut(`/api/cards/update_pin`, {
    payload: params
  });

  return response.data;
}

export async function putConfirmSetNewCardPinApi(
  params: ApiCallParams<ConfirmCardPinUpdateVm>
) {
  const response = await apiPut(`/api/cards/finish_update_pin`, {
    payload: params
  });

  return response.data;
}

export async function putCardStatusAsLostApi(params: ApiCallParams<string>) {
  const response = await apiPut(`/api/cards/${params}/lost`);

  return response.data;
}

export async function putCardStatusAsStolenApi(params: ApiCallParams<string>) {
  const response = await apiPut(`/api/cards/${params}/stolen`);

  return response.data;
}

export async function putCardStatusAsFrozenApi(params: ApiCallParams<string>) {
  const response = await apiPut(`/api/cards/${params}/frozen`);

  return response.data;
}

export async function putCardStatusAsActiveApi(params: ApiCallParams<string>) {
  const response = await apiPut(`/api/cards/${params}/active`);

  return response.data;
}

export async function getAllTransactionsApi(
  params: ApiCallParams<CardCriteria>
) {
  const query = params ? qs.stringify(params) : "";
  const response = await apiGet(`/api/cards/transactions?${query}`);

  if (response.data) {
    const result: TransactionStatement = response.data;
    return result;
  }

  return undefined;
}

export async function getOldTransactionsAccessTokenApi(code: string) {
  const response = await apiPost(
    `/api/cards/transactions/generateaccesstoken/${code}`
  );

  return response.data;
}

export async function getLatestTransactionsApi() {
  const response = await apiGet<TransactionDto[]>(
    `/api/cards/transactions/latest`
  );

  if (response.data) {
    const result: TransactionDto[] = response.data;
    return result;
  }

  return undefined;
}
